<div class="d-flex flex-column">
  @if (props.label) {
    <span class="italic d-inline-flex w-25">{{
      props.resourceId ? (props.resourceId | apmTranslate) : props.label
    }}</span>
  }
  @for (field of field.fieldGroup; track $index) {
    <div class="d-flex flex-column flex-1">
      <formly-field [field]="field"></formly-field>
    </div>
  }
</div>
